import React from 'react';
import { ArrowDownIcon, SearchIcon } from '../../assets/icons';
import { Variation } from '../../@types/inventory';
import BinIcon from '../../assets/icons/BinIcon';
import ListInventoryBody from '../inventory/list/ListInventoryBody';

export const VariationTable = (props: any) => {
  const [data, setData] = React.useState<typeof props.data>([]);

  React.useEffect(() => {
    setData(props.data);
  }, [props.data]);

  const tableHead = [
    { dataIndex: 'index', title: '#', className: 'text-center' },
    { dataIndex: 'name', title: 'Variation' },
    { dataIndex: 'type', title: 'Variation Type' },
    { dataIndex: 'price', title: 'Unit Price' },
    { dataIndex: 'quantity', title: 'Quantity' },
    { dataIndex: 'bin', title: null, icon: <BinIcon />, className: '' },
  ];

  return (
    
    <>
      <h2 className="font-semibold mt-12 text-[20px]">Variations</h2>
      <ListInventoryBody data={data} isLoading={props.isLoading} showPagination={false} tableHead={tableHead} />
    </>
  );
};

export default VariationTable;
